import styles from './Image.module.css';

export interface ImageProps {
  src: string;
  alt: string;
  width?: number | string;
  loading?: 'lazy' | 'eager';
  className?: string;
}

export function Image({
  src,
  alt,
  width,
  loading = 'lazy',
  className,
}: ImageProps) {
  return (
    <img
      data-crd-id="r2.bq-image"
      data-crd-layer="r2"
      src={src}
      alt={alt}
      width={width}
      loading={loading}
      className={`${styles.image} ${className ?? ''}`}
    />
  );
}
